import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      players: {
        bonuses: {
          form: {
            aasm_state: 'AASM_STATE',
            cid: 'CID',
            bonus_amount: 'BONUS_AMOUNT',
            date: 'DATE',
          },
          add_bonus: {
            header: 'HEADER',
            add_bonus: 'PLAYERS_BONUSES_ADD_BONUS',
            back: 'BACK',
            tabs: {
              manual: {
                tab_name: 'CREATE_MANUALLY_TAB',
              },
            },
          },
        },
      },
    },
  }));
}
